import { bpHistory } from 'global/bpHistory';

export function syncSubscriberIdToUrl(subscriberId: string): void {
  const params = new URLSearchParams(bpHistory.location.search);
  params.set('subscriberId', subscriberId);
  bpHistory.replace({
    pathname: bpHistory.location.pathname,
    search: params.toString(),
  });
}
